import { render, staticRenderFns } from "./SeriesRecetteTile.vue?vue&type=template&id=1a5e95d0&scoped=true&"
import script from "./SeriesRecetteTile.vue?vue&type=script&lang=js&"
export * from "./SeriesRecetteTile.vue?vue&type=script&lang=js&"
import style0 from "./SeriesRecetteTile.vue?vue&type=style&index=0&id=1a5e95d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e95d0",
  null
  
)

component.options.__file = "SeriesRecetteTile.vue"
export default component.exports